{{#each uvcInstancesWithoutDimensions delimeter="\n" tn=uvcInstancesWithDimensions.length}}
{{> (partial "harness/interface-instance") context=.. uvcInstance=.}}
{{/each}}
{{#each dimensionPropertiesListWithUvcInstances ln=uvcInstancesWithoutDimensions.length delimeter="\n"}}
{{> (partial "harness/generate-interface-instances") harness=.. dimensionPropertiesList=dimensionPropertiesList blockNamePrefix=blockNamePrefixes.instances uvcInstances=uvcInstances}}
{{/each}}

